import {MutableRefObject, useCallback} from "react";
import {useAppSelector} from "../../../redux/hooks";
import {
  getMySongsPageFilterGenresMenuTitle
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {useDivRef} from "../../../components/common/hooks/useDivRef";
import {useOnClickOutside} from "../../../components/common/hooks/useOnOutsideClick";
import {MySongsPageMenuType} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterGenreDropdownMenuLogic {
  isAvailable: boolean;
  label: string;
  onClickMenuToggleHandler: () => void;
  isActive?: boolean;
  dropdownFilterMenuRef: MutableRefObject<HTMLDivElement>;
}

const menuName: MySongsPageMenuType = `desktop.genre`;

export const useFilterGenreDropdownMenuLogic = (): IFilterGenreDropdownMenuLogic => {

  const menuLabel = useAppSelector(getMySongsPageFilterGenresMenuTitle);
  const isAvailable = useAppSelector(mySongsFiltersStore.getGenreIds).length > 1;
  const isActive = useAppSelector(() => mySongsPageStore.isMenuActive(menuName));

  const onClickOutsideMenuCloseHandler = useCallback(() => {
    if (!isActive) {
      // not active, no reason to close
      return;
    }
    mySongsPageStore.removeActiveMenu(menuName);
  }, [isActive]);

  const dropdownFilterMenuRef = useDivRef();
  useOnClickOutside<HTMLDivElement>(dropdownFilterMenuRef, onClickOutsideMenuCloseHandler);

  return {
    isAvailable,
    isActive,
    onClickMenuToggleHandler: () => mySongsPageStore.toggleSingleActiveMenu(menuName),
    label: menuLabel,
    dropdownFilterMenuRef,
  };
}
